(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vip-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initCountdown(root) {
      const launch = Date.parse(root.dataset.launch);
      if (Number.isNaN(launch)) return;
      const el = (u) => root.querySelector('[data-vip-' + u + ']');
      const parts = { days: el('days'), hours: el('hours'), minutes: el('minutes'), seconds: el('seconds') };
      const eyebrow = root.querySelector('[data-vip-eyebrow]');
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const ms = Math.max(0, launch - Date.now());
        parts.days.textContent = pad(Math.floor(ms / 86400000));
        parts.hours.textContent = pad(Math.floor(ms / 3600000) % 24);
        parts.minutes.textContent = pad(Math.floor(ms / 60000) % 60);
        parts.seconds.textContent = pad(Math.floor(ms / 1000) % 60);
        if (ms === 0) {
          eyebrow.textContent = root.dataset.labelLive;
          clearInterval(id);
        }
      };
      const id = setInterval(tick, 1000);
      tick();
    }

    function initVideo(root) {
      const video = root.querySelector('[data-vip-video]');
      if (!video) return;
      const restart = () => {
        video.currentTime = 0;
        video.play().catch(() => {});
      };
      if (video.readyState >= 1) restart();
      else video.addEventListener('loadedmetadata', restart, { once: true });
    }

    // Adds the email to the Klaviyo list that runs the nurture flow (browser API, public key only)
    function subscribeKlaviyo(state, email) {
      const key = state.dataset.klaviyoKey;
      const lists = (state.dataset.klaviyoList || '').split(',').map((id) => id.trim()).filter(Boolean);
      if (!key || !lists.length || !email) return;
      lists.forEach((list) => subscribeKlaviyoList(key, list, email));
    }

    function subscribeKlaviyoList(key, list, email) {
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Pre-Black Friday VIP page',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).catch(() => {});
    }

    function trackRegistration() {
      const url = new URL(location.href);
      if (!url.searchParams.has('customer_posted')) return;
      if (alreadyRegistered()) return;
      markRegistered();
      sendRegistration();
    }

    // customer_posted=true stays in the address, so a refresh must not count twice
    function alreadyRegistered() {
      try {
        return sessionStorage.getItem('vip-registered') === '1';
      } catch (err) {
        return false;
      }
    }

    function markRegistered() {
      try {
        sessionStorage.setItem('vip-registered', '1');
      } catch (err) {
        return;
      }
    }

    function sendRegistration(pageView) {
      let tries = 0;
      const send = () => {
        if (typeof window.fbq === 'function') {
          if (pageView) window.fbq('track', 'PageView');
          window.fbq('track', 'CompleteRegistration', { content_name: 'Pre-Black Friday VIP' });
          window.fbq('trackCustom', 'Registration', { content_name: 'Pre-Black Friday VIP' });
          return;
        }
        if (tries++ < 20) setTimeout(send, 500);
      };
      send();
    }

    function saveResume(root, email) {
      const data = { at: Date.now(), email: email, y: window.scrollY, t: 0, frame: '', cards: '', m: 0, dur: '' };
      const video = root.querySelector('[data-vip-video]');
      if (video && video.videoWidth) {
        video.pause();
        data.t = video.currentTime;
        try {
          const scale = Math.min(1, 1280 / video.videoWidth);
          const canvas = document.createElement('canvas');
          canvas.width = Math.round(video.videoWidth * scale);
          canvas.height = Math.round(video.videoHeight * scale);
          canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
          data.frame = canvas.toDataURL('image/jpeg', 0.7);
        } catch (err) {
          data.frame = '';
        }
      }
      const track = root.querySelector('.vip-reviews__track');
      const group = root.querySelector('.vip-reviews__group');
      if (track && group) {
        const anim = track.getAnimations()[0];
        data.cards = group.innerHTML;
        data.m = anim ? Number(anim.currentTime) || 0 : 0;
        data.dur = track.style.animationDuration;
        track.style.animationPlayState = 'paused';
      }
      try {
        sessionStorage.setItem('vip-resume', JSON.stringify(data));
      } catch (err) {
        data.frame = '';
      }
    }

    function initForm(root) {
      const form = root.querySelector('form');
      const state = root.querySelector('[data-vip-state]');
      if (!form || !state) return;
      const idle = root.querySelector('[data-vip-idle]');
      const error = root.querySelector('[data-vip-error]');
      const input = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');

      if (state.hasAttribute('data-vip-posted')) {
        if (!alreadyRegistered()) subscribeKlaviyo(state, input.value);
        trackRegistration();
        setTimeout(() => {
          state.classList.remove('is-loading');
          state.classList.add('is-done');
          input.disabled = true;
          button.disabled = true;
        }, 600);
      }

      const hp = root.querySelector('[data-vip-hp]');
      const reset = (msg) => {
        state.classList.remove('is-loading');
        idle.textContent = idle.dataset.label;
        button.disabled = false;
        error.textContent = msg;
        error.hidden = false;
      };

      form.addEventListener('submit', (e) => {
        error.hidden = true;
        state.classList.add('is-loading');
        idle.textContent = 'Registering…';
        const endpoint = state.dataset.endpoint;
        if (!endpoint || state.dataset.fallback) {
          saveResume(root, input.value);
          return;
        }
        e.preventDefault();
        button.disabled = true;
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: input.value, company: hp ? hp.value : '' })
        })
          .then((res) => res.json().catch(() => ({})).then((body) => ({ res: res, body: body })))
          .then((out) => {
            if (out.res.ok) {
              state.classList.remove('is-loading');
              state.classList.add('is-done');
              input.disabled = true;
              const url = new URL(location.href);
              url.searchParams.set('customer_posted', 'true');
              history.replaceState(null, '', url.pathname + url.search);
              markRegistered();
              sendRegistration(true);
              subscribeKlaviyo(state, input.value);
              return;
            }
            if (out.res.status === 400 || out.res.status === 429) {
              reset(out.body.error || 'Something went wrong. Try again.');
              return;
            }
            throw new Error('signup endpoint failed');
          })
          .catch(() => {
            state.dataset.fallback = '1';
            button.disabled = false;
            const type = form.querySelector('[data-vip-name]');
            if (form.dataset.vipAction) form.setAttribute('action', form.dataset.vipAction);
            if (type) type.setAttribute('name', 'form_type');
            let sent = false;
            const go = () => {
              if (sent) return;
              sent = true;
              form.requestSubmit();
            };
            if (window.Shopify && Shopify.captcha && Shopify.captcha.protect) {
              Shopify.captcha.protect(form, go);
              setTimeout(go, 4000);
            } else {
              go();
            }
          });
      });
    }

    function fillMarquee(wrap) {
      const groups = wrap.querySelectorAll('.vip-reviews__group');
      const track = wrap.querySelector('.vip-reviews__track');
      if (!groups.length || !track) return;
      const base = [...groups[0].children];
      if (!base.length) return;
      const target = Math.max(window.innerWidth, wrap.clientWidth) + 200;
      let guard = 0;
      while (groups[0].scrollWidth < target && guard++ < 20) {
        groups.forEach((group) => base.forEach((card) => group.appendChild(card.cloneNode(true))));
      }
      track.style.animationDuration = Math.max(30, Math.round(groups[0].scrollWidth / 45)) + 's';
    }

    function initReviews(root) {
      const wrap = root.querySelector('[data-vip-reviews]');
      if (!wrap) return;
      fillMarquee(wrap);
      if (!wrap.dataset.key || !wrap.dataset.place) return;
      const groups = wrap.querySelectorAll('.vip-reviews__group');
      const g = wrap.querySelector('.vip-review__g');
      fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(wrap.dataset.place), {
        headers: { 'X-Goog-Api-Key': wrap.dataset.key, 'X-Goog-FieldMask': 'reviews' }
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          const hidden = (wrap.dataset.exclude || '').toLowerCase().split(',').map((n) => n.trim()).filter(Boolean);
          const reviews = ((data && data.reviews) || []).filter((r) => {
            const who = ((r.authorAttribution && r.authorAttribution.displayName) || '').toLowerCase();
            return r.rating >= 4 && r.text && r.text.text && !hidden.includes(who);
          });
          if (!reviews.length) return;
          const build = () => reviews.map((r) => {
            const card = document.createElement('figure');
            card.className = 'vip-review';
            if (g) card.appendChild(g.cloneNode(true));
            const stars = document.createElement('span');
            stars.className = 'vip-review__stars';
            stars.setAttribute('aria-label', r.rating + ' out of 5 stars');
            stars.textContent = '★★★★★'.slice(0, Math.round(r.rating));
            const text = document.createElement('blockquote');
            text.className = 'vip-review__text';
            const t = r.text.text.trim();
            text.textContent = t.length > 170 ? t.slice(0, 167).trim() + '…' : t;
            const a = r.authorAttribution || {};
            const author = document.createElement(a.uri ? 'a' : 'span');
            author.className = 'vip-review__author';
            if (a.uri) {
              author.href = a.uri;
              author.target = '_blank';
              author.rel = 'noopener nofollow';
            }
            if (a.photoUri) {
              const img = document.createElement('img');
              img.className = 'vip-review__avatar';
              img.src = a.photoUri;
              img.alt = '';
              img.width = 28;
              img.height = 28;
              img.loading = 'lazy';
              img.referrerPolicy = 'no-referrer';
              author.appendChild(img);
            }
            const name = document.createElement('figcaption');
            name.className = 'vip-review__name';
            name.textContent = a.displayName || 'Google user';
            author.appendChild(name);
            card.append(stars, text, author);
            return card;
          });
          const liveNames = reviews.map((r) => ((r.authorAttribution && r.authorAttribution.displayName) || '').toLowerCase());
          const seen = new Set();
          const saved = [...groups[0].children].filter((card) => {
            const n = card.querySelector('.vip-review__name');
            const who = n ? n.textContent.trim().toLowerCase() : '';
            if (!who || seen.has(who) || liveNames.includes(who) || hidden.includes(who)) return false;
            seen.add(who);
            return true;
          });
          groups.forEach((group) => group.replaceChildren(...build(), ...saved.map((card) => card.cloneNode(true))));
          fillMarquee(wrap);
        })
        .catch(() => {});
    }

    // The page shows at once: no logo intro, no fade-in. A returning visitor's video is
    // resumed by the inline script above, so it is only restarted on a fresh load.
    function initIntro(root) {
      if (!document.documentElement.classList.contains('vip-returning')) initVideo(root);
      root.querySelector('[data-vip-title]').classList.add('is-shimmer');
    }

    document.querySelectorAll('[data-vip-hero]').forEach((root) => {
      initCountdown(root);
      initForm(root);
      initReviews(root);
      initIntro(root);
    });

    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('[data-vip-hero]');
      if (!root) return;
      initCountdown(root);
      initForm(root);
      initIntro(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
